import React, { Component } from "react";
import AppHeader from "./AppHeader";
import PropTypes from "prop-types";
import ReduxToastr from "react-redux-toastr";
import axios from "axios";
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';
import configureStore from '../store/configureStore';

// Components for routes
import CampaignsIndex from './CampaignsIndex';
import CampaignsNew from './CampaignsNew';
import CampaignsShow from './CampaignsShow';
import StarterCampaignsIndex from './StarterCampaignsIndex';
import SubscriptionsIndex from './SubscriptionsIndex';
import TemplatesIndex from './TemplatesIndex';
import TemplatesNew from './TemplatesNew';
import TemplatesEdit from './TemplatesEdit';
import SentEmail from './SentEmail';
import SMSTemplatesIndex from './SMSTemplatesIndex';
import SMSTemplatesNew from './SMSTemplatesNew';
import SMSTemplatesEdit from './SMSTemplatesEdit';
import CompanyStatus from './CompanyStatus';
import Help from './Help';
import CompanySettingsEdit from './CompanySettingsEdit';
import CompanyGeekAI from './CompanyGeekAI';
import EmailBroadcastsIndex from './EmailBroadcastsIndex';
import EmailBroadcastEmailsIndex from './EmailBroadcastEmailsIndex';
import CampaignEmailsIndex from './CampaignEmailsIndex';
import CampaignPostcardsIndex from './CampaignPostcardsIndex';
import CampaignSMSIndex from './CampaignSMSIndex';
import CampaignRVMIndex from './CampaignRVMIndex';
import AdminCompaniesIndex from './admin/AdminCompaniesIndex';
import AdminStarterCampaignsIndex from './admin/AdminStarterCampaignsIndex';
import AdminStarterCampaignsNew from './admin/AdminStarterCampaignsNew';
import AdminSentEmailsIndex from './admin/AdminSentEmailsIndex';
import AdminEmailAddressesIndex from './admin/AdminEmailAddressesIndex';
import AdminEmailBroadcastsIndex from './admin/AdminEmailBroadcastsIndex';
import AdminLeadsIndex from './admin/AdminLeadsIndex';
import AdminLeadFilterLogsIndex from './admin/AdminLeadFilterLogsIndex';
import TermsPage from './TermsPage';
import TermsVoicemailPage from './TermsVoicemailPage';
import Logout from './Logout';
import RVMTemplatesIndex from './RVMTemplatesIndex';
import RVMTemplatesNew from './RVMTemplatesNew';
import RVMTemplatesEdit from './RVMTemplatesEdit';
import VideoTemplatesIndex from './VideoTemplatesIndex';
import VideoTemplatesNew from './VideoTemplatesNew';
import VideoTemplatesEdit from './VideoTemplatesEdit';
import ReactiveResponsesEdit from './ReactiveResponsesEdit';
import Analytics from './Analytics';

import { TopNav, SideNav } from '@realgeeks/sextant';

const store = configureStore();

export class App extends Component {
  render() {
    const ROOT_URL = process.env.API_ROOT_URL.replace("/v1", "");

    let featureFlags = JSON.parse(localStorage.getItem('featureFlags'));

    let site_uuid = null;
    // Convert the old url format
    if (window.location.hash != "") {
      const pathArray = window.location.hash.split('/');
      if (pathArray && pathArray[1]) {
        site_uuid = pathArray[1];
        localStorage.setItem('lastSiteUUID', site_uuid);
        window.location = window.location.origin + "/" + pathArray.splice(2).join("/");
        return null;
      }
    }

    // If this is a redirect from Oauth, parse the params to get user LM id and admin status
    const params = window.location.href.split('?')[1];
    if (params && params !== '') {
        const paramHash = params.split('&').reduce(function (res, item) {
                const parts = item.split('=');
                res[parts[0]] = parts[1];
                return res;
            }, {});
        if (paramHash.user_external_id) {
          localStorage.setItem('userExternalId', paramHash.user_external_id);
        }
        if (paramHash.admin == 'true') {
          localStorage.setItem('showAdminLinks', true);
        }
        if (paramHash.site_uuid) {
          site_uuid = paramHash.site_uuid;
          localStorage.setItem('lastSiteUUID', site_uuid);
        }
    }

    // Get LM user id for Intercom
    let user_external_id = localStorage.getItem('userExternalId');

    // if (site_uuid == null && localStorage.getItem('lastSiteUUID')) {
    //   site_uuid = localStorage.getItem('lastSiteUUID');
    // } else {
    //   window.location = ROOT_URL + "/auth/realgeeks/";
    //   return null;
    // }

    if (site_uuid == null && localStorage.getItem('lastSiteUUID')) {
      site_uuid = localStorage.getItem('lastSiteUUID');
    }

    if (site_uuid == null || site_uuid == "undefined") {
      window.location = ROOT_URL + "/auth/realgeeks/";
      return null;
    } else {
      localStorage.setItem('lastSiteUUID', site_uuid);
    }

    const workflowsFF = featureFlags?.['harkon'];
    const navRemapFF = featureFlags?.['harkon_templates'];

    let override;
    if(navRemapFF) {
      override = {
        communication: {
          title: 'Inbox',
          subNavs: [
            {
              slug: 'templates',
              link: '/inbox/templates/emails',
              position: 8.5,
            },

            {
              slug: 'eblast',
              name: 'eBlasts',
              app: 'drip',
              link: `/#/${site_uuid}/eblasts`,
            },

            {
              slug: 'videos',
              name: 'Videos',
              app: 'drip',
              link: `/#/${site_uuid}/video_templates`,
            },

            { slug: 'postcards', position: 8 },
            {
              slug: 'message-settings',
              name: 'Message Settings',
              link: '/preferences/communications/email_integration',
              position: 8.75
            },
          ]
        },

        drip: {
          title: 'Automations',
          icon: 'Split',
          subNavs: [
            (workflowsFF && {
              slug: 'workflows',
              name: 'Drip Workflows',
              link: '/drip',
              app: 'lm'
            }),
            { slug: 'emails', remove: true },
            { slug: 'eblast', remove: true },
            { slug: 'sms', remove: true },
            { slug: 'videos', remove: true },
            { slug: 'library', name: 'Drip Library', position: 1.5 },
            { slug: 'reactive-responses', position: 1.75 },
          ]
        }
      };
    } else if(workflowsFF) {
      override = {
        drip: {
          subNavs: [{ slug: 'workflows', link: '/drip', app: 'lm' }]
        }
      };
    }

    const sextantProps = {
      optionProps: {
        appName: "Workflow - Drip",
        appColor: "#355d84",
        appIconClass: "edit-website",
        siteSelected: function(site) {
          localStorage.setItem('lastSiteUUID', site.uuid);
          window.history.pushState(null, null, "/campaigns/");
          setTimeout(function() {
            window.location.reload(true);
          }, 500);
        },
        appNameLink: "/",
        logout
      },
      current_user_data: {
        callback_url: "",
        site_uuid,
      }
    };

    function logout() {
      localStorage.removeItem('showAdminLinks');
      axios.get(ROOT_URL + "/logout").then(function(response) {
        window.location =
          "https://login.realgeeks.com/oauth/logout?next=" +
          ROOT_URL +
          "/auth/realgeeks/";
      });
    }

    function tosLink() {
      if (localStorage.getItem('agreedTOS') == true) {
        return (
          <Link
            to={'/terms'}
            className=""
          >
            {" "}
            You have agreed to the Terms of Service.{" "}
          </Link>
        );
      }
    }

    return (
      <div className="wrp">
        <Provider store={store}>
          <BrowserRouter>
            <TopNav {...sextantProps} />

            <AppHeader />
            {featureFlags?.['sextant_sidenav'] && (
              <div className="side-navigation">
                <SideNav
                  hostName="drip"
                  hostEnv={process.env.NODE_ENV}
                  siteUUID={site_uuid}
                  callbackUrl=""
                  overrideConfigs={override || {}}
                />
              </div>
            )}
            <ReduxToastr timeOut={6000} newestOnTop={false} position="top-center" />
            <div className="container cnt">
              <Analytics id="G-7JR9JFDHCG" user_id={user_external_id}>
                <Switch>
                  <Route path="/logout" component={Logout} />
                  <Route path="/" exact component={CampaignsIndex} />
                  <Route path="/campaigns" exact component={CampaignsIndex} />
                  <Route path="/campaigns/new" exact component={CampaignsNew} />
                  <Route path="/campaigns/:id" exact component={CampaignsShow} />
                  <Route path="/campaigns/:id/versions/:version_id" component={CampaignsShow} />
                  <Route path="/campaigns/:id/emails" component={CampaignEmailsIndex} />
                  <Route path="/campaigns/:id/postcards" component={CampaignPostcardsIndex} />
                  <Route path="/campaigns/:id/sms" component={CampaignSMSIndex} />
                  <Route path="/campaigns/:id/rvms" component={CampaignRVMIndex} />
                  <Route path="/campaigns/:id/subscriptions" component={SubscriptionsIndex} />
                  <Route path="/starter_campaigns" exact component={StarterCampaignsIndex} />
                  <Route path="/templates" exact component={TemplatesIndex} />
                  <Route path="/templates/new" exact component={TemplatesNew} />
                  <Route path="/templates/:id" component={TemplatesEdit} />
                  <Route path="/sent_emails/:id" component={SentEmail} />
                  <Route path="/sms_templates" exact component={SMSTemplatesIndex} />
                  <Route path="/sms_templates/new" exact component={SMSTemplatesNew} />
                  <Route path="/sms_templates/:id" component={SMSTemplatesEdit} />
                  <Route path="/eblasts" exact component={EmailBroadcastsIndex} />
                  <Route path="/eblasts/:id/emails" component={EmailBroadcastEmailsIndex} />
                  <Route path="/status" component={CompanyStatus} />
                  <Route path="/help" component={Help} />
                  <Route path="/settings" component={CompanySettingsEdit} />
                  <Route path="/admin/companies" component={AdminCompaniesIndex} />
                  <Route path="/admin/starter_campaigns" exact component={AdminStarterCampaignsIndex} />
                  <Route path="/admin/starter_campaigns/new" component={AdminStarterCampaignsNew} />
                  <Route path="/admin/sent_emails" component={AdminSentEmailsIndex} />
                  <Route path="/admin/email_addresses" component={AdminEmailAddressesIndex} />
                  <Route path="/admin/email_broadcasts" component={AdminEmailBroadcastsIndex} />
                  <Route path="/admin/leads" exact component={AdminLeadsIndex} />
                  <Route path="/admin/leads/:id/filter_logs" component={AdminLeadFilterLogsIndex} />
                  <Route path="/usage/voicemail" exact component={TermsVoicemailPage} />
                  <Route path="/terms" component={TermsPage} />
                  <Route path="/rvm_templates" exact component={RVMTemplatesIndex} />
                  <Route path="/rvm_templates/new" exact component={RVMTemplatesNew} />
                  <Route path="/rvm_templates/:id" component={RVMTemplatesEdit} />
                  <Route path="/video_templates" exact component={VideoTemplatesIndex} />
                  <Route path="/video_templates/new" exact component={VideoTemplatesNew} />
                  <Route path="/video_templates/:id" component={VideoTemplatesEdit} />
                  <Route path="/geek_ai" component={CompanyGeekAI} />
                  <Route path="/reactive_responses" exact component={ReactiveResponsesEdit} />

                </Switch>
              </Analytics>
            </div>
            <div className="terms-notice">{tosLink()}</div>
          </BrowserRouter>
        </Provider>
      </div>
    );
  }
}

export default App;
